<template>
    <!-- Generic Slider -->
    <slider-generic
    hideCircles
    :selectedIndex="selectedIndex"
    :sliderList="products"
    @updateSelectedIndex="selectedIndex = $event">
        <!-- products cards components -->
        <component
        :is="cardsComponent"
        :colors="colors"
        :products="products"
        :selectedTab="selectedTab"
        :selectedProduct="selectedProduct"
        :selectedCurrency="selectedCurrency"
        @cardClicked="emit('cardClicked', $event)" />
    </slider-generic>
</template>

<script setup>
import SliderGeneric from '@/components/generic/sliders/Generic'
import AllProductsCards from '@/components/features/accounts/patrimony/chart/mobile/AllProductsCards'
import SpecificProductCards from '@/components/features/accounts/patrimony/chart/mobile/SpecificProductCards'

/* Vue */
import { ref, computed, watch, onMounted } from 'vue'

/** Props
@selectedCurrency {string} - selected currency in our picker
@selectedProduct {string} - the current selected product
@products {array} - array with products
@colors {array} - array with products colors
@selectedTab {string} - active tab description
*/
const props = defineProps({
    selectedCurrency: String,
    selectedProduct: String,
    products: Array,
    colors: Array,
    selectedTab: String
})

const emit = defineEmits(['cardClicked', 'scrolledToCard'])

const selectedIndex = ref(null)

/**********************************************************************
*                                                                     *
*                             Cards Logic                             *
*                                                                     *
**********************************************************************/
const cardsComponent = computed(() => {
    return props.selectedProduct === 'allProducts' ? AllProductsCards : SpecificProductCards
})

const scrolledToCardEmit = (id, percentage, parsedPercentage, color) => {
    emit('scrolledToCard', {
        id: id,
        percentage: percentage,
        parsedPercentage: parsedPercentage,
        percentageColor: color
    })
}

const resetToFirstCard = () => {
    if (!props.products.length) return

    scrolledToCardEmit(
        props.selectedProduct === 'allProducts' ? props.products[0].description : props.products[0].accountNumber,
        props.products[0].percentage,
        props.products[0].parsedPercentage,
        props.colors[0]
    )
}

watch(() => props.selectedTab, () => {
    resetToFirstCard()
})

watch(() => props.products, () => {
    resetToFirstCard()
})

watch(() => selectedIndex.value, () => {
    scrolledToCardEmit(
        props.selectedProduct === 'allProducts' ? props.products[selectedIndex.value].description : props.products[selectedIndex.value].accountNumber,
        props.products[selectedIndex.value].percentage,
        props.products[selectedIndex.value].parsedPercentage,
        props.colors[selectedIndex.value]
    )
})

onMounted(() => {
    resetToFirstCard()
})
</script>

<style lang="scss" scoped>
.cards-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 16px;

    overflow: hidden;

    .before,
    .after {
        width: calc((100% - 248px - 32px) / 2);
        height: 130px;
        flex-shrink: 0;
    }
}
</style>
